/** @jsxImportSource @emotion/react */
import { useParams } from "react-router-dom";
import useConfig from "../../../../../actions/Tenants/config/configHook";
import { useAddFruitImage, useDeleteFruitImage, useFruitImages } from "../../../../../hooks/useFruitImages";
import { isFilledArray } from "../../../../../utils";
import { useQcEntities } from "../../QcEntityContext";
import ManualImages from "../ManualImages";

// Use for create purchase order reports
// Where we can have multiple check in one view
export default function FruitImages({ avocado_id }: { avocado_id: number }) {
    const config = useConfig();
    const { check, layer } = useQcEntities();
    const avocado = check.avocados.find((a) => a.avocado_id === avocado_id) || {};
    const location = config.get_check_type_config(layer, check);
    const params = useParams();

    // Get all fruit_images fields to extract required images from options
    // Multiple fruit-images fields can be configured in a single form
    const fruitFormFields = config.get_fruit_form(layer, check, avocado);
    const fruitImagesFields = fruitFormFields.filter((f: any) => f.type === "fruit-images");

    // Merge required images from all fruit-images fields
    // If fields are hidden by display_filter, options will be empty
    const required_fruit_images = fruitImagesFields.flatMap((f: any) => f?.options || []);

    const currentFlow = location?.flow?.find((f) => f.path === params.action);
    const flowHasRequiredImages = !currentFlow?.disable_required_images;

    // Fetch fruit images using TanStack Query
    const { data: images = [], isLoading } = useFruitImages(avocado.tenant_id, avocado_id);
    const addImageMutation = useAddFruitImage();
    const deleteImageMutation = useDeleteFruitImage();

    const addFruitImage = async (type, base64, focusMode) => {
        return addImageMutation.mutateAsync({ tenantId: avocado.tenant_id, avocadoId: avocado_id, type, base64, focusMode });
    };

    const deleteFruitImage = async (image) => {
        return deleteImageMutation.mutateAsync({ tenantId: avocado.tenant_id, avocadoId: avocado_id, image });
    };

    if (!isFilledArray(required_fruit_images) || !flowHasRequiredImages) {
        return null;
    }

    return (
        <div>
            <ManualImages
                images={images || []}
                required_images={required_fruit_images}
                saveImage={addFruitImage}
                deleteImage={deleteFruitImage}
                isLoading={isLoading || addImageMutation.isPending || deleteImageMutation.isPending}
            />
        </div>
    );
}
